import { render, staticRenderFns } from "./DemoComponent.vue?vue&type=template&id=053a4d6e&"
import script from "./DemoComponent.vue?vue&type=script&lang=js&"
export * from "./DemoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports